import { useEffect, useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import styles from './SoportePage.module.css';

function etiquetaFecha(fechaStr) {
  const hoy  = new Date();
  const ayer = new Date(); ayer.setDate(ayer.getDate() - 1);
  const f    = new Date(fechaStr);
  const same = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth()    === b.getMonth()    &&
    a.getDate()     === b.getDate();
  if (same(f, hoy))  return 'Hoy';
  if (same(f, ayer)) return 'Ayer';
  return f.toLocaleDateString('es-ES', { weekday:'long', day:'2-digit', month:'long', year:'numeric' });
}
function claveFecha(fechaStr) {
  const d = new Date(fechaStr);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export default function SoportePage() {
  const { user } = useAuth();
  const [conv, setConv]           = useState(null);
  const [loading, setLoading]     = useState(true);
  const [respuesta, setRespuesta] = useState('');
  const [adjunto, setAdjunto]     = useState(null);
  const [enviando, setEnviando]   = useState(false);
  const endRef     = useRef(null);
  const adjuntoRef = useRef(null);

  const cargar = async () => {
    setLoading(true);
    try {
      const r = await api.get('/soporte');
      setConv(r.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior:'smooth' }); }, [conv]);

  const enviar = async e => {
    e.preventDefault();
    if (!respuesta.trim() && !adjunto) return;
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append('contenido', respuesta);
      if (adjunto) fd.append('adjunto', adjunto);
      await api.post(`/conversaciones/${conv.id}/responder`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setRespuesta('');
      setAdjunto(null);
      if (adjuntoRef.current) adjuntoRef.current.value = '';
      const r = await api.get('/soporte');
      setConv(r.data.data);
    } finally { setEnviando(false); }
  };

  const abrirAdjunto = (msgId, soloUrl = false) => {
    const token = localStorage.getItem('token');
    const url = `https://eduportalual.com/backend/api/x7Kp9mQ2/conversaciones/${conv.id}/adjunto/${msgId}`;
    const full = url + (token ? '?token=' + encodeURIComponent(token) : '');
    if (soloUrl) return full;
    window.open(full, '_blank');
  };

  const formatHora = d => new Date(d).toLocaleTimeString('es-ES', { hour:'2-digit', minute:'2-digit' });

  const mensajesConSeparadores = () => {
    const msgs = conv?.mensajes || [];
    const result = []; let ultima = null;
    msgs.forEach(m => {
      const clave = claveFecha(m.created_at);
      if (clave !== ultima) { result.push({ tipo:'sep', fecha: m.created_at, clave }); ultima = clave; }
      result.push({ tipo:'msg', ...m });
    });
    return result;
  };

  const nombreMostrado = (msg) => {
    if (msg.autor_rol === 'admin') return 'Soporte EduPortal';
    return `${msg.autor_nombre ?? ''} ${msg.autor_apellidos ?? ''}`.trim();
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.headerIcon}>🎧</div>
        <div>
          <h2 className={styles.headerTitle}>Soporte Técnico</h2>
          <p className={styles.headerSub}>
            Escríbenos cualquier duda o problema. El equipo de soporte te responderá lo antes posible.
          </p>
        </div>
      </div>

      <div className={styles.chatBox}>
        {loading && <p className={styles.empty}>Cargando...</p>}
        {!loading && (
          <>
            <div className={styles.mensajesList}>
              {(!conv?.mensajes || conv.mensajes.length === 0) && (
                <div className={styles.emptyChat}>
                  <p className={styles.emptyChatIcon}>💬</p>
                  <p className={styles.emptyChatText}>No hay mensajes aún. ¡Escríbenos tu primera consulta!</p>
                </div>
              )}
              {mensajesConSeparadores().map((item) => {
                if (item.tipo === 'sep') {
                  return (
                    <div key={`sep-${item.clave}`} className={styles.fechaSep}>
                      <span className={styles.fechaSepTexto}>{etiquetaFecha(item.fecha)}</span>
                    </div>
                  );
                }
                const esMio = Number(item.autor_id) === Number(user?.id);
                return (
                  <div key={item.id} className={`${styles.msgRow} ${esMio ? styles.msgMio : styles.msgOtro}`}>
                    {!esMio && <div className={styles.msgAvatarSoporte}>🎧</div>}
                    <div className={`${styles.msgBubble} ${esMio ? styles.bubbleMio : styles.bubbleOtro}`}>
                      {!esMio && <p className={styles.msgAutor}>{nombreMostrado(item)}</p>}
                      {item.contenido && <p className={styles.msgTexto}>{item.contenido}</p>}
                      {item.adjunto_nombre && (
                        /\.(png|jpg|jpeg|gif|webp)$/i.test(item.adjunto_nombre)
                          ? <img
                              src={abrirAdjunto(item.id, true)}
                              alt={item.adjunto_nombre}
                              className={styles.adjuntoImg}
                              onClick={() => window.open(abrirAdjunto(item.id, true), '_blank')}
                            />
                          : <button className={styles.adjuntoBtn}
                              onClick={() => window.open(abrirAdjunto(item.id, true), '_blank')}>
                              📎 {item.adjunto_nombre}
                            </button>
                      )}
                      <p className={styles.msgHora}>{formatHora(item.created_at)}</p>
                    </div>
                  </div>
                );
              })}
              <div ref={endRef} />
            </div>

            <form onSubmit={enviar} className={styles.responderForm}>
              {adjunto && (
                <div className={styles.adjuntoPrevio}>
                  {/\.(png|jpg|jpeg|gif|webp)$/i.test(adjunto.name) ? '🖼️' : '📎'} {adjunto.name}
                  <button type="button" onClick={() => { setAdjunto(null); if (adjuntoRef.current) adjuntoRef.current.value = ''; }}>✕</button>
                </div>
              )}
              <div className={styles.responderRow}>
                <textarea
                  className={styles.responderInput}
                  placeholder="Escribe tu mensaje... (Enter para enviar, Shift+Enter para nueva línea)"
                  value={respuesta} rows={2}
                  onChange={e => setRespuesta(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviar(e); }
                  }}
                />
                <input ref={adjuntoRef} type="file"
                  accept=".pdf,.doc,.docx,.txt,.zip,.png,.jpg,.jpeg,.gif,.webp"
                  style={{ display:'none' }}
                  onChange={e => setAdjunto(e.target.files[0] || null)}
                />
                <button type="button" className={styles.btnAdjunto}
                  onClick={() => adjuntoRef.current?.click()} title="Adjuntar archivo">📎</button>
                <button type="submit" className={styles.btnResponder}
                  disabled={enviando || (!respuesta.trim() && !adjunto)}>
                  {enviando ? '…' : '➤'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
